import React from 'react'
import { get } from 'lodash'
import { IoMdCheckmarkCircleOutline, IoIosCloseCircle } from 'react-icons/io'
import ResultsModal from './ResultsModal'

function isError(status) {
  return typeof status === 'string'
    && (status.startsWith('Completed with errors') || status.startsWith('Error'))
}

function isCompleted(status) {
  return typeof status === 'string' && status.startsWith('Completed') && !isError(status)
}

export default function StatusDisplay(record, column) {
  const status = get(record, column.key)
  const failures = get(record, 'result.failures', [])

  if (failures.length > 0) {
    return (
      <div className="approval-state">
        <i title="Completed with errors"><IoIosCloseCircle size={30} className="error" /></i>
        <span>{status}</span>
        <ResultsModal failures={failures} />
      </div>
    )
  }

  if (isError(status)) {
    return (
      <div className="approval-state">
        <i title="Error"><IoIosCloseCircle size={30} className="error" /></i>
        <span>{status}</span>
      </div>
    )
  }

  if (isCompleted(status)) {
    return (
      <div className="approval-state">
        <i title="Completed"><IoMdCheckmarkCircleOutline size={30} className="success" /></i>
        <strong className="success">{status}</strong>
      </div>
    )
  }

  return status || ''
}
